module.exports = __webpack_public_path__ + "static/media/settings.38f3cc15.svg";